export default {
  primary: process.env.VUE_APP_VUETIFY_THEME_PRIMARY,
  secondary: '#06CBB3',
  accent: '#82B1FF',
  error: '#FF3739',
  info: '#00D0BD',
  success: '#00D014',
  warning: '#FFB70F',
  background: '#a0a0a0'
}
